// export const baseUrl = 'http://10.111.7.7';
// export const baseUrl = 'http://test5.genee.cn';
export const baseUrl = 'http://10.111.7.7';
export const official = 'https://buaa.edu.cn/';
export const management = 'https://sysc.buaa.edu.cn/';
export const lab = 'http://10.111.7.7/uno/#/student/app-entry';
export const school = 'http://10.111.7.7/uno/#/scool/app-entry';
export const admin = 'http://10.111.7.7/uno/#/admin/app-entry';
export const warehouse = 'http://10.111.7.7/uno/#/warehouse/app-entry';

